/**
 * @generated SignedSource<<88a617d6227a986cca3ba785c28a4552>>
 * @relayHash 6ea31507d555ff62422b83cfba3c5a5d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4f6d98da2f46f400e89dd6bfeb7dddff5d178c5d87774df7dfe9bd11948425b2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery } from './uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery.graphql';

const node: PreloadableConcreteRequest<uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4f6d98da2f46f400e89dd6bfeb7dddff5d178c5d87774df7dfe9bd11948425b2",
    "metadata": {},
    "name": "uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
